document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 990) return;

  document.querySelectorAll(".header__inline-menu details").forEach((item) => {
    item.addEventListener("mouseenter", () => {
      item.setAttribute("open", "");
      item.querySelector("summary")?.setAttribute("aria-expanded", "true");
    });

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      item.querySelector("summary")?.setAttribute("aria-expanded", "false");
    });
  });
});